module.exports = __webpack_public_path__ + "img/american-flag-image.153d4180.svg";